module.exports = __webpack_public_path__ + "static/media/floral-ornament-svgrepo-com (1).ba505998.svg";